import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbar } from '@angular/material/toolbar';
import { ButtonsContainerComponent } from './buttons-container/buttons-container.component';
import { NgCommonModule } from './ng-common.module';

@NgModule({
  imports: [
    ButtonsContainerComponent,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIcon,
    MatInputModule,
    MatSelectModule,
    MatToolbar,
    NgCommonModule,
    ReactiveFormsModule,
  ],
  exports: [
    ButtonsContainerComponent,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIcon,
    MatInputModule,
    MatSelectModule,
    MatToolbar,
    NgCommonModule,
    ReactiveFormsModule,
  ],
})
export class NgDialogModule {}
